<template>
  <div class="constrain-width mobile">
    <PageHeader
      :goBack="hasBackwardsNavEnabled ? goBack : null"
      :headerArch="pageHeaderArch"
      :title="pageTitle"
    />
    <Transition>
      <LoadingPage
        v-if="pageType === pageTypes.loading"
        :key="`${pageTypes.loading}-${pageId}`"
        :content="pageData"
        :action="() => setCurrentPage(defaultProgression)"
      />
      <GetStartedPage
        v-else-if="pageType === pageTypes.getStarted"
        :key="`${pageTypes.getStarted}-${pageId}`"
        :content="pageData"
        :action="() => setCurrentPage(defaultProgression)"
      />
      <SingleSelectPage
        v-else-if="pageType === pageTypes.singleSelect"
        :key="`${pageTypes.singleSelect}-${pageId}`"
        :content="pageData"
        :items="pageData.options"
        :componentType="componentType"
        :action="(item) => updateData(item.value, item.to, item.target_field)"
      />
      <LetUsKnowPage
        v-else-if="pageType === pageTypes.letUsKnow"
        :key="`${pageTypes.letUsKnow}-${pageId}`"
        :content="pageData"
        :action="() => setCurrentPage(defaultProgression)"
      />
      <MultiSelectPage
        v-else-if="pageType === pageTypes.multiSelect"
        :key="`${pageTypes.multiSelect}-${pageId}`"
        :content="pageData"
        :items="pageData.options"
        :action="(list) => updateData(list, defaultProgression, targetField)"
      />
      <PillMultiSelectPage
        v-else-if="pageType === pageTypes.multiPillSelect"
        :key="`${pageTypes.multiPillSelect}-${pageId}`"
        :content="pageData"
        :items="pageData.options"
        :action="(list) => updateData(list, defaultProgression, targetField)"
      />
      <CaroselPage
        v-else-if="pageType === pageTypes.carosel"
        :key="`${pageTypes.carosel}-${pageId}`"
        :content="pageData"
        :action="() => setCurrentPage(defaultProgression)"
      />
      <CategoryPage
        v-else-if="pageType === pageTypes.category"
        :key="`${pageTypes.category}-${pageId}`"
        :content="pageData"
        :action="() => setCurrentPage(defaultProgression)"
      />
      <StepPage
        v-else-if="pageType === pageTypes.step"
        :key="`${pageTypes.step}-${pageId}`"
        :content="pageData"
        :items="pageData.options"
        :action="() => setCurrentPage(defaultProgression)"
      />
      <SummaryPage
        v-else-if="pageType === pageTypes.summary"
        :key="`${pageTypes.summary}-${pageId}`"
        :content="pageData"
        :items="pageData.options"
        :action="() => setCurrentPage(defaultProgression)"
      />
      <InfoPage
        v-else-if="pageType === pageTypes.info"
        :key="`${pageTypes.info}-${pageId}`"
        :content="pageData"
        :action="() => setCurrentPage(defaultProgression)"
      />
      <InputPage
        v-else-if="pageType === pageTypes.input"
        :key="`${pageTypes.input}-${pageId}`"
        :content="pageData"
        :action="(value) => updateData(value, defaultProgression, targetField)"
      />
      <AvatarPage
        v-else-if="pageType === pageTypes.avatarSelect"
        :key="`${pageTypes.avatarSelect}-${pageId}`"
        :content="pageData"
        :action="(item) => updateData(item.value, item.to, item.target_field)"
      />
      <DetailsPage
        v-else-if="pageType === pageTypes.details"
        :key="`${pageTypes.details}-${pageId}`"
        :content="pageData"
        :action="() => setCurrentPage(defaultProgression)"
      />
      <EthnicityPage
        v-else-if="pageType === pageTypes.ethnicity"
        :key="`${pageTypes.ethnicity}-${pageId}`"
        :content="pageData"
        :items="pageData.options"
        :action="(list) => updateData(list, defaultProgression, targetField)"
      />
      <PaymentDownloadPage
        v-else-if="pageType === pageTypes.paymentDownload"
        :key="`${pageTypes.paymentDownload}-${pageId}`"
        :content="pageData"
      />
      <PaymentSuccessPage
        v-else-if="pageType === pageTypes.paymentSuccess"
        :key="`${pageTypes.paymentSuccess}-${pageId}`"
        :content="pageData"
        :action="() => setCurrentPage(defaultProgression)"
      />
      <WebPaymentDeliveryPage
        v-else-if="pageType === pageTypes.paymentDelivery"
        :key="`${pageTypes.paymentDelivery}-${pageId}`"
        :action="() => setCurrentPage(defaultProgression)"
        :updateFormState="updateFormState"
        :formData="webForm"
      />
      <WebPaymentPlanPage
        v-else-if="pageType === pageTypes.paymentPlan"
        :key="`${pageTypes.selectPlan}-${pageId}`"
        :action="() => setCurrentPage(defaultProgression)"
        :updateFormState="updateFormState"
        :formData="webForm"
      />
      <WebPaymentSetupAccountPage
        v-else-if="pageType === pageTypes.paymentSetupAccount"
        :key="`${pageTypes.paymentSetupAccount}-${pageId}`"
        :action="
          (name, name_target, email, email_target) => {
            updateData(name, defaultProgression, name_target);
            updateData(email, defaultProgression, email_target);
          }
        "
        :updateFormState="
          (field, value, touched) =>
            updateFormState('webForm', field, value, touched)
        "
        :formData="webForm"
      />
      <WebPaymentSetupAccountAllianzPage
        v-else-if="pageType === pageTypes.paymentSetupAccountAllianz"
        :key="`${pageTypes.paymentSetupAccountAllianz}-${pageId}`"
        :action="(email) => updateData(email, defaultProgression, targetField)"
        :updateFormState="
          (field, value, touched) =>
            updateFormState('webForm', field, value, touched)
        "
        :formData="webForm"
      />
      <AFQTypeformAllianzPage
        v-else-if="pageType === pageTypes.afqTypeformAllianz"
        :key="`${pageTypes.afqTypeformAllianz}-${pageId}`"
        :content="pageData"
        :action="() => setCurrentPage(defaultProgression)"
      />
      <InfoAllianzPage
        v-else-if="pageType === pageTypes.infoAllianz"
        :key="`${pageTypes.infoAllianz}-${pageId}`"
        :content="pageData"
        :action="() => setCurrentPage(defaultProgression)"
      />
      <PartnerPaymentDeliveryPage
        v-else-if="pageType === pageTypes.partnerOnboardingDelivery"
        :action="() => setCurrentPage(defaultProgression)"
        :updateFormState="updateFormState"
        :formData="partnerForm"
        :webForm="webForm"
      />
      <PartnerPaymentPlanPage
        v-else-if="pageType === pageTypes.partnerOnboardingPlan"
        :action="() => setCurrentPage(defaultProgression)"
        :updateFormState="updateFormState"
        :formData="partnerForm"
        :webForm="webForm"
      />
      <PartnerPaymentSetupAccountPage
        v-else-if="pageType === pageTypes.partnerOnboardingSetupAccount"
        :key="`${pageTypes.partnerOnboardingSetupAccount}-${pageId}`"
        :action="(email) => updateData(email, defaultProgression, targetField)"
        :updateFormState="
          (field, value, touched) =>
            updateFormState('partnerForm', field, value, touched)
        "
        :formData="partnerForm"
      />
    </Transition>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as queryString from "query-string";
import {
  TARGET_DATA,
  MODULES,
  PAGE_TYPES,
  PAYMENT_FORMS,
  webPaymentFields,
  defaultWebPaymentFormState,
  partnerPaymentFields,
  partnerFormState,
} from "@/config";
import {
  createFormState,
  parseOnboardingDataToSegment,
  updateSegmentUser,
} from "@/utils";
import { pageInformationMixin } from "@/mixins/index.js";
import PageHeader from "@/components/PageHeader.vue";
import SingleSelectPage from "./SingleSelect/PageSingleSelect.vue";
import MultiSelectPage from "./MultiSelect/PageMultiSelect.vue";
import InputPage from "./Input/PageInput.vue";
import InfoPage from "./Info/PageInfo.vue";
import LoadingPage from "./Loading/PageLoading.vue";
import PillMultiSelectPage from "./MultiPillSelect/PageMultiPillSelect.vue";
import CaroselPage from "./Carosel/PageCarosel.vue";
import CategoryPage from "./Category/PageCategory.vue";
import StepPage from "./Step/PageStep.vue";
import SummaryPage from "./Summary/PageSummary.vue";
import AvatarPage from "./Avatar/PageAvatar.vue";
import DetailsPage from "./Details/PageDetails.vue";
import WebPaymentDeliveryPage from "./WebPayment/Delivery/PageWebPaymentDelivery.vue";
import WebPaymentPlanPage from "./WebPayment/Plan/PageWebPaymentSelectPlan.vue";
import WebPaymentSetupAccountPage from "./WebPayment/SetupAccount/PageWebPaymentSetupAccount.vue";
import WebPaymentSetupAccountAllianzPage from "./Allianz/PageWebPaymentSetupAccountAllianz.vue";
import AFQTypeformAllianzPage from "./Allianz/PageAFQTypeformAllianz.vue";
import InfoAllianzPage from "./Allianz/PageInfoAllianz.vue";
import PaymentDownloadPage from "./Success/PagePaymentDownload.vue";
import PaymentSuccessPage from "./Success/PagePaymentSuccess.vue";
import PartnerPaymentPlanPage from "./PartnerPayment/Plan/PagePartnerPaymentSelectPlan.vue";
import PartnerPaymentDeliveryPage from "./PartnerPayment/Delivery/PagePartnerPaymentDelivery.vue";
import GetStartedPage from "./GetStarted/PageGetStarted.vue";
import LetUsKnowPage from "./LetUsKnow/PageLetUsKnow.vue";
import PartnerPaymentSetupAccountPage from "./WebPayment/SetupAccount/PageWebPaymentSetupAccount.vue";
import EthnicityPage from "./Ethnicity/PageEthnicity.vue";

export default {
  data() {
    return {
      pageTypes: PAGE_TYPES,
      [PAYMENT_FORMS.web]: createFormState(
        webPaymentFields,
        defaultWebPaymentFormState
      ),
      [PAYMENT_FORMS.partner]: createFormState(
        partnerPaymentFields,
        partnerFormState
      ),
    };
  },
  components: {
    PageHeader,
    LoadingPage,
    InputPage,
    InfoPage,
    SingleSelectPage,
    LetUsKnowPage,
    MultiSelectPage,
    PillMultiSelectPage,
    AvatarPage,
    DetailsPage,
    CaroselPage,
    CategoryPage,
    StepPage,
    SummaryPage,
    WebPaymentDeliveryPage,
    WebPaymentPlanPage,
    WebPaymentSetupAccountPage,
    WebPaymentSetupAccountAllianzPage,
    AFQTypeformAllianzPage,
    InfoAllianzPage,
    PaymentDownloadPage,
    PaymentSuccessPage,
    PartnerPaymentPlanPage,
    PartnerPaymentDeliveryPage,
    GetStartedPage,
    PartnerPaymentSetupAccountPage,
    EthnicityPage,
  },
  mixins: [pageInformationMixin],
  computed: {
    ...mapGetters(MODULES.APP, {
      pageField: "getPageField",
      currentPage: "getCurrentPage",
    }),
    ...mapGetters(MODULES.WELCOME, {
      onboardingData: "getOnboardingData",
    }),
    ...mapGetters(MODULES.ANXIETY, {
      anxietyData: "getAnxietyData",
    }),
    // Todo: Move to page data layer (has_header_arch: true)
    showHeaderArch() {
      switch (this.pageType) {
        case PAGE_TYPES.paymentDelivery:
          return true;
        case PAGE_TYPES.paymentPlan:
          return true;
        case PAGE_TYPES.partnerOnboardingPlan:
          return true;
        case PAGE_TYPES.partnerOnboardingDelivery:
          return true;
        case PAGE_TYPES.paymentSetupAccount:
          return true;
        default:
          return false;
      }
    },
  },
  mounted() {
    const { goBack } = this;

    window.addEventListener("popstate", function () {
      goBack();
    });
  },
  watch: {
    currentPage: {
      handler(currentPage, previousPage) {
        if (!previousPage) {
          return;
        }
        const data = {
          ...this.onboardingData,
          ...this.anxietyData,
        };

        this.pushPageHistory(currentPage);
        this.trackUserMovements(previousPage, data);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    pushPageHistory(currentPage) {
      const search = location.hash.replace("#/", "");
      const obj = queryString.parse(search);

      let prettyPageName = "error";

      if (currentPage) {
        prettyPageName = currentPage?.split("_page")?.[0];
      }

      obj.i = prettyPageName;

      history.pushState(null, null, `#/?${queryString.stringify(obj)}`);
    },
    updateFormState(formName, field, value, touched) {
      this[formName][field] = { value, touched };
    },
    trackUserMovements(currentPage, data) {
      const result = parseOnboardingDataToSegment(currentPage, data);

      if (result.parameters !== null && window?.analytics) {
        window.analytics.identify({
          ...updateSegmentUser(currentPage, data)?.parameters,
        });
        window.analytics.track(result.eventName, {
          ...result.parameters,
          Host: "Web",
        });
      }
    },
    updateData(data, pageName, targetField) {
      const { dispatch } = this.$store;
      const { setCurrentPage, targetState, targetPages } = this;

      let module = null;

      if (data === "open_clinician_portal") {
        window.location.href =
          "https://app.ovrcome.io/clinic/onboarding/account";
        return;
      }

      switch (targetState) {
        case TARGET_DATA.anxiety:
          module = MODULES.ANXIETY;
          break;
        case TARGET_DATA.welcome:
          module = MODULES.WELCOME;
          break;
        case TARGET_DATA.webPayment:
        case TARGET_DATA.partnerPayment:
          module = MODULES.PAYMENT;
          break;
        default:
          break;
      }

      dispatch(`${module}/setData`, {
        fieldName: targetField,
        data,
      })
        .then(() =>
          dispatch(`${MODULES.APP}/updatePageContent`, {
            pages: targetPages,
            data,
          })
        )
        .then(() => setCurrentPage(pageName));
    },
    setCurrentPage(item) {
      const { dispatch } = this.$store;

      dispatch(`${MODULES.APP}/setCurrentPage`, item);
    },
    goBack() {
      const { dispatch } = this.$store;

      dispatch(`${MODULES.APP}/setGoBackPage`);
    },
  },
};
</script>
